<script lang="ts" setup>
  import { computed, type Component } from 'vue'
  import { useI18n } from 'vue-i18n'
  import CCPayment from '@/shared/components/icons/CCPayment.vue'
  import NapsPayment from '@/shared/components/icons/NapsPayment.vue'
  import ApplePayIcon from '@/shared/components/icons/ApplePayIcon.vue'
  import type { PaymentOption } from '@/shared/types/api.types'

  interface Props {
    options: PaymentOption[]
    modelValue: string
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
  }>()

  const { t } = useI18n()

  const model = computed({
    get() {
      return props.modelValue
    },
    set(value) {
      emit('update:modelValue', value)
    },
  })

  const PAYMENT_ICON_HASH: Record<string, Component> = {
    CC: CCPayment,
    DC: NapsPayment,
    APPLEPAY: ApplePayIcon,
    AP: ApplePayIcon,
  }

  const PAYMENT_TRANSLATE_HASH: Record<string, string> = {
    CC: 'checkout.payment_block.credit_card.title',
    DC: 'checkout.payment_block.naps_debit.title',
  }

  const getPaymentText = (type: string, description: string) => {
    const translateKey = PAYMENT_TRANSLATE_HASH[type]
    if (translateKey) {
      return t(translateKey)
    }

    return description
  }
</script>

<template>
  <ul class="payment-options">
    <li v-for="{ paymtType, paymDesc } in options" :key="paymtType" class="payment-options__el">
      <label>
        <input v-model="model" :value="paymtType" type="radio" name="paymentType" />
        <span class="payment-options__el-circle"></span>
        {{ getPaymentText(paymtType, paymDesc) }}

        <Component
          v-if="PAYMENT_ICON_HASH[paymtType]"
          :is="PAYMENT_ICON_HASH[paymtType]"
          class="payment-options__el-icon"
          :class="{ 'payment-options__el-icon--disabled': model !== paymtType }"
        />
      </label>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
  @import './PaymentOptions';
</style>
